export default "https://cdn.questicon.mathletics.com/assets/images/keypad-5da137d6b31ba3cd35dc08909ed7309d.svg";